import React, { Component } from "react";
import { connect } from "react-redux";

import { Wrapper, Row, Copy, Bold } from "app/NativeComponents/common";
import { PillButton } from "app/NativeComponents/snippets";

import {
  appRedirect,
  setFeatureModal,
  openUrl,
  getBilling,
  setPricingPage,
  togglePricingPage,
  toggleDemoPage,
  setDemoPage
} from "app/NativeActions";

class InfoBanner extends Component {
  constructor(props) {
    super(props);

    this.state = {
      info_banner: null
    };
  }

  componentDidMount() {
    this.setState({
      info_banner: this.determineInfoBanner(this.props.info_banner_type)
    });
  }

  componentDidUpdate(prevProps) {
    if (this.props.info_banner_type !== prevProps.info_banner_type) {
      this.setState({
        info_banner: this.determineInfoBanner(this.props.info_banner_type)
      });
    } else if (
      this.props.plan_modules !== prevProps.plan_modules ||
      this.props.card_info !== prevProps.card_info
    ) {
      this.setState({
        info_banner: this.determineInfoBanner(this.props.info_banner_type, true)
      });
    } else if (
      this.props.driving_info_banner !== prevProps.driving_info_banner ||
      this.props.lists_info_banner !== prevProps.lists_info_banner ||
      this.props.messages_info_banner !== prevProps.messages_info_banner ||
      this.props.crm_info_banner !== prevProps.crm_info_banner
    ) {
      if (
        this.props.info_banner_type == "driving_info_banner" &&
        this.props.driving_info_banner &&
        this.props.driving_info_banner.current_count >=
          this.props.driving_info_banner.limit &&
        this.props.driving_info_banner.limit != -1 &&
        this.props.driving_info_banner.limit != 0
      ) {
        this.props.setPricingPage({
          title:
            this.props.driving_info_banner.button_type == "purchase"
              ? "Get Started"
              : this.props.driving_info_banner.button_type == "reactivate"
              ? "Reactivate"
              : "Upgrade",
          engine_slug: "driving",
          tier: this.props.driving_info_banner.next_plan_tier,
          frequency: this.props.driving_info_banner.current_frequency
        });
        this.props.togglePricingPage(true);
      } else if (
        this.props.info_banner_type == "lists_info_banner" &&
        this.props.lists_info_banner &&
        this.props.lists_info_banner.current_count >=
          this.props.lists_info_banner.limit &&
        this.props.lists_info_banner.limit != -1 &&
        this.props.lists_info_banner.limit != 0
      ) {
        this.props.setPricingPage({
          title:
            this.props.lists_info_banner.button_type == "purchase"
              ? "Get Started"
              : this.props.lists_info_banner.button_type == "reactivate"
              ? "Reactivate"
              : "Upgrade",
          engine_slug: "lists",
          tier: this.props.lists_info_banner.next_plan_tier,
          frequency: this.props.lists_info_banner.current_frequency
        });
        this.props.togglePricingPage(true);
      } else if (
        this.props.info_banner_type == "messages_info_banner" &&
        this.props.messages_info_banner &&
        this.props.messages_info_banner.current_count >=
          this.props.messages_info_banner.limit &&
        this.props.messages_info_banner.limit != -1 &&
        this.props.messages_info_banner.limit != 0
      ) {
        this.props.setPricingPage({
          title:
            this.props.messages_info_banner.button_type == "purchase"
              ? "Get Started"
              : this.props.messages_info_banner.button_type == "reactivate"
              ? "Reactivate"
              : "Upgrade",
          engine_slug: "messages",
          tier: this.props.messages_info_banner.next_plan_tier,
          frequency: this.props.messages_info_banner.current_frequency
        });
        this.props.togglePricingPage(true);
      }

      this.setState({
        info_banner: this.determineInfoBanner(
          this.props.info_banner_type,
          false
        )
      });
    }
  }

  determineInfoBanner(info_banner_type, load_more = true) {
    if (!!info_banner_type) {
      let info_banner;
      const {
        driving_info_banner,
        lists_info_banner,
        messages_info_banner,
        crm_info_banner
      } = this.props;
      switch (info_banner_type) {
        case "driving_info_banner":
          info_banner = driving_info_banner;
          break;
        case "lists_info_banner":
          info_banner = lists_info_banner;
          break;
        case "messages_info_banner":
          info_banner = messages_info_banner;
          break;
        case "crm_info_banner":
          info_banner = crm_info_banner;
          break;
        default:
          break;
      }
      if (load_more) {
        this.props.getBilling({
          token: this.props.token,
          type: info_banner_type
        });
      }

      return info_banner;
    }

    return null;
  }

  renderInfoWrapper(color, children = () => {}) {
    if (this.props.device == "desktop") {
      return (
        <Wrapper className="dm-info-banner" style={{ backgroundColor: color }}>
          {children()}
        </Wrapper>
      );
    } else {
      return (
        <Wrapper style={{ width: "100%" }}>
          <Wrapper
            style={{
              paddingBottom: this.props.isIphoneX
                ? 20
                : this.props.platform == "ios"
                ? 10
                : 10,
              backgroundColor: color,
              padding: 10
            }}
          >
            {children()}
          </Wrapper>
        </Wrapper>
      );
    }
  }

  renderFixCardButton() {
    if (this.props.platform != "ios") {
      return (
        <PillButton
          innerStyle={{ paddingTop: 5, paddingBottom: 5 }}
          onPress={() => {
            this.props.appRedirect({
              redirect: "cardOnFile"
            });
          }}
        >
          Fix Card On File
        </PillButton>
      );
    } else {
      return (
        <PillButton
          innerStyle={{ paddingTop: 5, paddingBottom: 5 }}
          onPress={() => {
            openUrl(
              "https://app.dealmachine.com/a/settings/billing/update-card"
            );
          }}
        >
          Fix It
        </PillButton>
      );
    }
  }

  render() {
    const { info_banner } = this.state;
    const { colors, user, card_info } = this.props;
    //render infobanner for bad card
    if (
      (user.team_clearance_level > 1 || user.team_owner == 1) &&
      user.canceled != 1
    ) {
      if (card_info.bad_card == 1) {
        return this.renderInfoWrapper(colors.error_color_muted, () => {
          return (
            <Row style={{ justifyContent: "center", alignItems: "center" }}>
              <Wrapper
                style={{
                  flex: this.props.device == "desktop" ? "inherit" : 1,
                  marginRight: this.props.device == "desktop" ? 0 : 10
                }}
              >
                <Copy
                  style={{
                    //color: this.props.colors.white_text_color,
                    padding: 10,
                    fontSize: this.props.device == "desktop" ? 14 : 12
                  }}
                >
                  {!!this.props.card_info.bad_card_reason ? (
                    <Bold>
                      Your card was declined (Reason:{" "}
                      {this.props.card_info.bad_card_reason})
                    </Bold>
                  ) : (
                    <Bold>Your card was declined.</Bold>
                  )}
                </Copy>
              </Wrapper>
              {this.renderFixCardButton()}
            </Row>
          );
        });
      }

      if (card_info.dealcredit_bad_card == 1) {
        return this.renderInfoWrapper(colors.error_color_muted, () => {
          return (
            <Row style={{ justifyContent: "center", alignItems: "center" }}>
              <Wrapper
                style={{
                  flex: this.props.device == "desktop" ? "inherit" : 1,
                  marginRight: this.props.device == "desktop" ? 0 : 10
                }}
              >
                <Copy
                  style={{
                    //color: this.props.colors.white_text_color,
                    padding: 10,
                    fontSize: this.props.device == "desktop" ? 14 : 12
                  }}
                >
                  <Bold>
                    Your card was declined. You cannot send mail or skip trace
                    until you update the card on file.
                  </Bold>
                </Copy>
              </Wrapper>
              {this.renderFixCardButton()}
            </Row>
          );
        });
      }

      if (info_banner && info_banner.show_banner == true) {
        return this.renderInfoWrapper(colors[info_banner.color], () => {
          return (
            <Row style={{ justifyContent: "center", alignItems: "center" }}>
              <Wrapper
                style={{
                  flex: this.props.device == "desktop" ? "inherit" : 1,
                  marginRight: this.props.device == "desktop" ? 0 : 10
                }}
              >
                <Copy
                  style={{
                    color: info_banner.text_color
                      ? colors[info_banner.text_color]
                      : this.props.colors.text_color,
                    padding: 10,
                    fontSize: this.props.device == "desktop" ? 14 : 12
                  }}
                >
                  <Bold>{info_banner.title}</Bold>
                </Copy>
              </Wrapper>
              <PillButton
                innerStyle={{ paddingTop: 5, paddingBottom: 5 }}
                onPress={() => {
                  switch (info_banner.button_type) {
                    case "training":
                      this.props.setDemoPage({
                        title: info_banner.button_text,
                        webinar_id: info_banner.webinar_id
                      });
                      this.props.toggleDemoPage(true);
                      break;

                    case "purchase":
                    case "upgrade":
                    case "reactivate":
                    default:
                      if (this.props.platform == "ios") {
                        openUrl(info_banner.ios_url);
                      } else {
                        this.props.setPricingPage({
                          title:
                            info_banner.button_type == "purchase"
                              ? "Get Started"
                              : info_banner.button_type == "reactivate"
                              ? "Reactivate"
                              : "Upgrade",
                          engine_slug: info_banner.slug,
                          tier: info_banner.next_plan_tier,
                          frequency: info_banner.current_frequency
                        });
                        this.props.togglePricingPage(true);
                      }

                      break;

                    case "link":
                      openUrl(info_banner.button_link);
                      break;
                  }
                }}
              >
                {info_banner.button_text}
              </PillButton>
            </Row>
          );
        });
      }

      if (this.props.user.pause_sending == 1) {
        return this.renderInfoWrapper(
          this.props.colors.error_color_muted,
          () => {
            return (
              <Row style={{ justifyContent: "center", alignItems: "center" }}>
                <Wrapper
                  style={{
                    flex: this.props.device == "desktop" ? "inherit" : 1,
                    marginRight: this.props.device == "desktop" ? 0 : 10
                  }}
                >
                  <Copy
                    style={{
                      padding: 10,
                      fontSize: this.props.device == "desktop" ? 14 : 12
                    }}
                  >
                    <Bold>
                      Your account is set to "Stop All Sending". No mail will be
                      sent at this time. You can change this in your account
                      settings.
                    </Bold>
                  </Copy>
                </Wrapper>
                <PillButton
                  innerStyle={{ paddingTop: 5, paddingBottom: 5 }}
                  onPress={() => {
                    this.props.appRedirect({ redirect: "settings" });
                  }}
                >
                  Go To Settings
                </PillButton>
              </Row>
            );
          }
        );
      }
    }
    return null;
  }
}

const mapStateToProps = ({ auth, settings, native, billing }) => {
  const { token, user } = auth;
  const { colors } = settings;
  const { device, platform, isMobile, isIphoneX } = native;
  const {
    card_info,
    plan_modules,
    driving_info_banner,
    lists_info_banner,
    messages_info_banner,
    crm_info_banner
  } = billing;
  return {
    token,
    user,
    device,
    platform,
    isMobile,
    card_info,
    plan_modules,
    driving_info_banner,
    lists_info_banner,
    messages_info_banner,
    crm_info_banner,
    colors
  };
};

export default connect(mapStateToProps, {
  appRedirect,
  getBilling,
  setFeatureModal,
  setPricingPage,
  togglePricingPage,
  toggleDemoPage,
  setDemoPage
})(InfoBanner);
